import { render } from "./2022-10-20-Proxy.md?vue&type=template&id=77520db7"
const script = {}
script.render = render

export default script